/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchDispute } from './MatchDispute';
import {
    MatchDisputeFromJSON,
    MatchDisputeFromJSONTyped,
    MatchDisputeToJSON,
    MatchDisputeToJSONTyped,
} from './MatchDispute';

/**
 * 
 * @export
 * @interface GetTournamentDisputesResponse
 */
export interface GetTournamentDisputesResponse {
    /**
     * 
     * @type {Array<MatchDispute>}
     * @memberof GetTournamentDisputesResponse
     */
    disputes: Array<MatchDispute>;
    /**
     * 
     * @type {number}
     * @memberof GetTournamentDisputesResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetTournamentDisputesResponse
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof GetTournamentDisputesResponse
     */
    skip: number;
}

/**
 * Check if a given object implements the GetTournamentDisputesResponse interface.
 */
export function instanceOfGetTournamentDisputesResponse(value: object): value is GetTournamentDisputesResponse {
    if (!('disputes' in value) || value['disputes'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('skip' in value) || value['skip'] === undefined) return false;
    return true;
}

export function GetTournamentDisputesResponseFromJSON(json: any): GetTournamentDisputesResponse {
    return GetTournamentDisputesResponseFromJSONTyped(json, false);
}

export function GetTournamentDisputesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTournamentDisputesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'disputes': ((json['disputes'] as Array<any>).map(MatchDisputeFromJSON)),
        'total': json['total'],
        'limit': json['limit'],
        'skip': json['skip'],
    };
}

export function GetTournamentDisputesResponseToJSON(json: any): GetTournamentDisputesResponse {
    return GetTournamentDisputesResponseToJSONTyped(json, false);
}

export function GetTournamentDisputesResponseToJSONTyped(value?: GetTournamentDisputesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'disputes': ((value['disputes'] as Array<any>).map(MatchDisputeToJSON)),
        'total': value['total'],
        'limit': value['limit'],
        'skip': value['skip'],
    };
}

